import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import CountUp from "react-countup";

import { useNavigate } from "react-router-dom";


import image1 from "../Images/Project01.jpg";
import image2 from "../Images/Project02.jpg";
import image3 from "../Images/Project03.jpg";
import image4 from "../Images/Project04.jpg";
import image5 from "../Images/Project05.jpg";
import image6 from "../Images/Project06.jpeg";
import image7 from "../Images/Project04.jpg";
import image8 from "../Images/Project05.jpg";
import image9 from "../Images/Project06.jpeg";
import "./Project.css";

const projectData = [
  {
    id: 1,
    category: ["Classic", "One Storey"],
    description:
      "A sophisticated penthouse transformation featuring contemporary design elements and breathtaking city views.",
    img: image1,
    details: { bedrooms: 3, bathrooms: 2, area: "1800 sqft" },
  },
  {
    id: 2,
    category: ["Modern", "One Storey"],
    description:
      "A warm and inviting family home that balances comfort with timeless elegance.",
    img: image2,
    details: { bedrooms: 4, bathrooms: 3, area: "2100 sqft" },
  },
  {
    id: 3,
    category: ["Classic", "One Storey"],
    description:
      "A cutting-edge office space designed to inspire creativity and productivity.",
    img: image3,
    details: { bedrooms: 2, bathrooms: 1, area: "1500 sqft" },
  },
  {
    id: 4,
    category: ["Classic", "Two Storey"],
    description:
      "An elegant hotel lobby that creates a memorable first impression for guests.",
    img: image4,
    details: { bedrooms: 5, bathrooms: 4, area: "3500 sqft" },
  },
  {
    id: 5,
    category: ["Modern", "Two Storey"],
    description:
      "A warm minimalist space that maximizes functionality while maintaining aesthetic appeal.",
    img: image5,
    details: { bedrooms: 3, bathrooms: 2, area: "2400 sqft" },
  },
  {
    id: 6,
    category: ["Modern", "Two Storey"],
    description:
      "A beautifully restored Victorian home that honors its historical character.",
    img: image6,
    details: { bedrooms: 4, bathrooms: 3, area: "2600 sqft" },
  },
  {
    id: 7,
    category: ["Classic", "Three Storey"],
    description:
      "An elegant hotel lobby that creates a memorable first impression for guests.",
    img: image7,
    details: { bedrooms: 6, bathrooms: 5, area: "4200 sqft" },
  },
  {
    id: 8,
    category: ["Modern", "Three Storey"],
    description:
      "A warm minimalist space that maximizes functionality while maintaining aesthetic appeal.",
    img: image8,
    details: { bedrooms: 5, bathrooms: 4, area: "3800 sqft" },
  },
  {
    id: 9,
    category: ["Classic", "Three Storey"],
    description:
      "A beautifully restored Victorian home that honors its historical character.",
    img: image9,
    details: { bedrooms: 7, bathrooms: 5, area: "4500 sqft" },
  },
];

export default function Projects() {
  const [filter, setFilter] = useState("All");
  const categories = ["All", "One Storey", "Two Storey", "Three Storey"];

  const filteredProjects =
    filter === "All"
      ? projectData
      : projectData.filter((proj) => proj.category.includes(filter));
  const navigate = useNavigate();
  return (
    <section className=" bg-white">
      {/* Header */}
      <div className="container text-center mb-5">
        <div className="project-header text-center text-black py-5">
          <div className="container">
            <h2 className="fw-bold display-5 mb-3">Our Projects</h2>
            <p className="lead mx-auto" style={{ maxWidth: "800px" }}>
              Explore our portfolio of stunning interior design projects that
              showcase our expertise in creating beautiful, functional spaces.
            </p>
          </div>
        </div>

        {/* Filter Buttons */}
        <div className="mt-4">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setFilter(cat)}
              className={`btn mx-2 mb-2 ${
                filter === cat
                  ? "btn-warning text-white"
                  : "btn-outline-secondary"
              } rounded-pill px-4 fw-semibold`}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>

      {/* Project Cards */}
      <div className="container">
      <div className="row g-4">
        {filteredProjects.map((proj) => (
          <div key={proj.id} className="col-md-6 col-lg-4">

            {/* === FULL CARD CLICKABLE === */}
            <div
              className="card border-0 shadow-lg h-100 project-card"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/Notpay")}
            >
              <div className="position-relative">
                <img
                  src={proj.img}
                  alt={proj.title}
                  className="card-img-top img-fluid"
                  style={{ height: "220px", objectFit: "cover" }}
                />

                <div className="position-absolute top-0 start-0 p-2 d-flex gap-2">
                  {proj.category.map((cat) => (
                    <span
                      key={cat}
                      className="badge bg-warning text-white rounded-pill"
                    >
                      {cat}
                    </span>
                  ))}
                </div>
              </div>

              <div className="card-body text-start">
                <h5 className="card-title fw-bold">{proj.title}</h5>
                <p className="card-text text-secondary">{proj.description}</p>

                {/* --- Icons Section --- */}
                {proj.details && (
                  <div className="d-flex justify-content-start gap-4 mb-3 text-secondary">
                    <div>
                      <i className="fa-solid fa-bed me-2 gradient-icon"></i>
                      {proj.details.bedrooms} Beds
                    </div>

                    <div>
                      <i className="fa-solid fa-bath me-2 gradient-icon"></i>
                      {proj.details.bathrooms} Baths
                    </div>

                    <div>
                      <i className="fa-solid fa-ruler-combined me-2 gradient-icon"></i>
                      {proj.details.area}
                    </div>
                  </div>
                )}

                {/* --- VIEW DETAILS (also clickable) --- */}
                <span
                  className="fw-semibold text-warning text-decoration-none"
                  onClick={(e) => {
                    e.stopPropagation(); // prevent card click conflict
                    navigate("/Pays");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  View Details →
                </span>

              </div>
            </div>

          </div>
          ))}
        </div>
      </div>

      {/* Stats Section */}
      <div className="stats-section text-center py-5 mt-5 bg-light">
        <div className="container d-flex justify-content-center gap-5 flex-wrap">
          <div className="stat-item">
            <h2>
              <CountUp start={0} end={200} duration={3} />+
            </h2>
            <p>Projects Completed</p>
          </div>

          <div className="stat-item">
            <h2>
              <CountUp start={0} end={98} duration={3} />%
            </h2>
            <p>Client Satisfaction</p>
          </div>

          <div className="stat-item">
            <h2>
              <CountUp start={0} end={20} duration={3} />+
            </h2>
            <p>Years Experience</p>
          </div>
        </div>
      </div>
    </section>
  );
}
